import { z } from "zod";

import type { BggConfigStatus } from "./BggConfigStatus";

export interface Settings {
	dateFormat: string;
	timeFormat: string;
	uiLanguage: string;
	currency: string;
	statistics: boolean;
	updateCheckEnabled: boolean;
	versionTrack: string;
	shelfOfShameEnabled: boolean;
	shelfOfShameMonthsLimit: number;
	publicUrl: string;
	gameNightsEnabled: boolean;
	rsvpAuthenticationEnabled: boolean;
	bggStatus: BggConfigStatus;
	bggApiKey: string | null;
}

export const SettingsSchema = z.object({
	dateFormat: z
		.string({
			error: "settings:date-format.required",
		})
		.min(1, {
			message: "settings:date-format.required",
		}),
	timeFormat: z
		.string({
			error: "settings:time-format.required",
		})
		.min(1, {
			message: "settings:time-format.required",
		}),
	uiLanguage: z.string({
		error: "settings:ui-language.required",
	}),
	currency: z
		.string({
			error: "settings:currency.required",
		})
		.min(1, {
			message: "settings:currency.required",
		}),
	publicUrl: z.string(),
	statistics: z.boolean(),
	updateCheckEnabled: z.boolean(),
	versionTrack: z.string(),
	shelfOfShameEnabled: z.boolean(),
	shelfOfShameMonthsLimit: z.number().min(1),
	gameNightsEnabled: z.boolean(),
	rsvpAuthenticationEnabled: z.boolean(),
	bggApiKey: z.string().nullable(),
});
